import { YourSpaceView } from './your-space-view';

export function DashboardPage() {
  return <YourSpaceView />;
}
